import { X } from 'lucide-react';
import { contactInfo } from '../../mock';
import { sendWhatsApp, WHATSAPP_REPLIES } from '../../lib/whatsapp';
import { WhatsAppIcon } from './WhatsAppIcon';

const PanelHeader = ({ close }) => (
  <div className="relative bg-[#25D366] px-5 py-4 flex items-center gap-3">
    <div className="w-10 h-10 rounded-full bg-white/95 flex items-center justify-center overflow-hidden"><img src="https://customer-assets.emergentagent.com/job_documentation-76/artifacts/iyu3j9j9_Asset%205.png" alt="Membratek" className="w-7 h-7 object-contain" /></div>
    <div className="flex-1 min-w-0">
      <div className="text-background font-semibold text-[14.5px] leading-tight">Membratek Asistan</div>
      <div data-testid="whatsapp-availability" className="text-background text-[11.5px] mt-0.5">WhatsApp ile iletisim</div>
    </div>
    <button data-testid="whatsapp-close-button" type="button" onClick={close} className="w-8 h-8 rounded-full hover:bg-black/10 text-background flex items-center justify-center transition-colors" aria-label="Kapat"><X size={16} /></button>
  </div>
);

const QuickReplies = () => (
  <div className="space-y-2 mb-3">
    {WHATSAPP_REPLIES.map((reply) => <button key={reply} data-testid={`whatsapp-reply-${reply.toLowerCase().replace(/\s+/g, '-')}`} type="button" onClick={() => sendWhatsApp(reply)} className="w-full text-left px-4 py-2.5 rounded-xl bg-input hover:bg-secondary border border-border hover:border-[#25D366]/40 text-[13px] text-white/85 hover:text-white transition-colors duration-200">{reply}</button>)}
  </div>
);

export const WhatsAppPanel = ({ close }) => (
  <div id="whatsapp-panel" data-testid="whatsapp-panel" className="fixed bottom-[88px] left-4 sm:left-6 z-[90] w-[calc(100vw-2rem)] max-w-[320px] sm:max-w-[360px] max-h-[calc(100dvh-110px)] overflow-y-auto rounded-2xl bg-card border border-border shadow-2xl animate-[fadeIn_0.25s_ease-out]">
    <PanelHeader close={close} />
    <div className="bg-background px-5 pt-5 pb-3">
      <div className="bg-input rounded-2xl rounded-tl-sm p-4 max-w-[90%] mb-3 border border-border">
        <p className="text-[13.5px] text-white/85 leading-relaxed">Merhaba! Membratek&apos;e hos geldiniz. Size nasil yardimci olabiliriz?</p>
        <p className="text-[10.5px] text-muted-foreground mt-2">Sorularinizi WhatsApp uzerinden iletebilirsiniz.</p>
      </div>
      <QuickReplies />
    </div>
    <div className="px-5 pb-5 pt-1">
      <button data-testid="whatsapp-start-chat-button" type="button" onClick={() => sendWhatsApp()} className="w-full inline-flex items-center justify-center gap-2 px-5 py-3.5 rounded-full bg-[#25D366] hover:bg-[#20bd5a] text-background text-[13px] font-semibold tracking-wide transition-colors duration-200 shadow-[0_8px_24px_-8px_rgba(37,211,102,0.5)]"><WhatsAppIcon className="w-4 h-4 fill-current" />WhatsApp&apos;ta Sohbet Baslat</button>
      <p data-testid="whatsapp-contact-number" className="text-[10.5px] text-muted-foreground text-center mt-3">Yanitlar {contactInfo.phone} numarasindan gelir</p>
    </div>
  </div>
);